import { collection, query, where, orderBy, limit, getDocs } from 'firebase/firestore';
import { db } from '../utils/firebase';

/**
 * Fetch last 20 items with status="win" and last 5 items with status="lost".
 * Returns an object: { wins: [...], lost: [...] }
 */
export async function getLastPredictions() {
  const colRef = collection(db, 'games'); // <-- use your actual collection name

  // Query the "win" documents
  const winQuery = query(
    colRef,
    where('status', '==', 'win'),
    orderBy('timestamp', 'desc'),
    limit(20)
  );
  const winSnap = await getDocs(winQuery);
  const wins = [];
  winSnap.forEach(doc => {
    wins.push({ id: doc.id, ...doc.data() });
  });

  // Query the "lost" documents
  const lostQuery = query(
    colRef,
    where('status', '==', 'lost'),
    orderBy('timestamp', 'desc'),
    limit(5)
  );
  const lostSnap = await getDocs(lostQuery);
  const lost = [];
  lostSnap.forEach(doc => {
    lost.push({ id: doc.id, ...doc.data() });
  });

  return { wins, lost };
}
